import React, { useState } from 'react';
const Address = ({ addresses, setAddresses }) => {
  const [editMode, setEditMode] = useState(false);
  const [editedAddress, setEditedAddress] = useState(null);
  const [editIndex, setEditIndex] = useState(null);

  const [newAddress, setNewAddress] = useState({
    "H.No": '',
    "Street": '',
    "Town": '',
    "District": '',
    "State": '',
    "Pin": ''
  });

  const [isAddingAddress, setIsAddingAddress] = useState(false);
  const [newAddressType, setNewAddressType] = useState('');
  const [customAddressName, setCustomAddressName] = useState(''); 

  const handleModify = (addressKey) => {
    setEditMode(true);
    setEditIndex(addressKey);
    setEditedAddress({ ...addresses[addressKey] });
  };

  const handleDelete = (addressKey) => {
    const updatedAddresses = { ...addresses };
    delete updatedAddresses[addressKey];
    setAddresses(updatedAddresses);
  };

  const handleSave = () => {
    const updatedAddresses = { ...addresses };
    updatedAddresses[editIndex] = { ...editedAddress };
    setAddresses(updatedAddresses);
    setEditMode(false);
    setEditedAddress(null);
    setEditIndex(null);
  };

  const handleCancel = () => {
    setEditMode(false);
    setEditedAddress(null);
    setEditIndex(null);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEditedAddress((prev) => ({ ...prev, [name]: value }));
  };

  const handleNewAddressChange = (e) => {
    const { name, value } = e.target;
    setNewAddress((prev) => ({ ...prev, [name]: value }));
  };

  const handleAddAddress = () => {
    let updatedAddresses = { ...addresses };

    
    const addressName = newAddressType === "Other's Address" && customAddressName ? customAddressName : newAddressType;

    // Structure the address data in the format with numeric keys (like Home Address and Office Address)
    if (addressName) {
      const structuredAddress = {};
      Object.entries(newAddress).forEach(([key, value], index) => {
        structuredAddress[index + 1] = { [key]: value }; 
      });

      updatedAddresses[addressName] = structuredAddress;
      setAddresses(updatedAddresses);
      setNewAddress({ "H.No": '', "Street": '', "Town": '', "District": '', "State": '', "Pin": '' });
      setNewAddressType('');
      setCustomAddressName('');  
      setIsAddingAddress(false);
    }
  };

  const disabledAddressNames = Object.keys(addresses);

  return (
    <div>
      {Object.entries(addresses).map(([addressName, address], index) => {
        const addressField = Object.entries(address);

        return (
          <div key={addressName} className="address-card">
            <h4>{addressName}</h4>
            {editMode && editIndex === addressName ? (
              <div>
                {addressField.map(([subKey, value], subIndex) => {
                  if (typeof value === 'object' && !Array.isArray(value)) {
                    return Object.entries(value).map(([nestedKey, nestedValue], nestedIndex) => (
                      <div key={nestedIndex}>
                        <label>{nestedKey}: </label>
                        <input
                          type="text"
                          name={nestedKey}
                          value={editedAddress[subKey] ? editedAddress[subKey][nestedKey] : ''}
                          onChange={(e) =>
                            setEditedAddress((prev) => ({
                              ...prev,
                              [subKey]: {
                                ...prev[subKey],
                                [nestedKey]: e.target.value,
                              },
                            }))
                          }
                        />
                      </div>
                    ));
                  }
                  return (
                    <div key={subIndex}>
                      <label>{subKey}: </label>
                      <input
                        type="text"
                        name={subKey}
                        value={editedAddress[subKey] || ''}
                        onChange={handleChange}
                      />
                    </div>
                  );
                })}
                <div className="address-actions">
                  <button onClick={handleSave}>Save</button>
                  <button onClick={handleCancel}>Cancel</button>
                </div>
              </div>
            ) : (
              <div>
                {addressField.map(([subKey, value], subIndex) => {
                  if (typeof value === 'object' && !Array.isArray(value)) {
                    return Object.entries(value).map(([nestedKey, nestedValue], nestedIndex) => (
                      <div key={nestedIndex}>
                        <strong>{nestedKey}:</strong> {nestedValue}
                      </div>
                    ));
                  }
                  return (
                    <div key={subIndex}>
                      <strong>{subKey}:</strong> {value}
                    </div>
                  );
                })}
                <div className="address-actions">
                  <button onClick={() => handleModify(addressName)}>Modify</button>
                  <button onClick={() => handleDelete(addressName)}>Delete</button>
                </div>
              </div>
            )}
          </div>
        );
      })}

      <div>
        {!isAddingAddress ? (
          <button onClick={() => setIsAddingAddress(true)}>Add Address</button>
        ) : (
          <div className="add-address">
            <h4>Add a New Address</h4>
            <div className="Address-type">
              <label>Select Address Type: </label>
              <select
                value={newAddressType}
                onChange={(e) => setNewAddressType(e.target.value)}
              >
                <option value="">Select Address Type</option>
                <option value="Home Address" disabled={disabledAddressNames.includes('Home Address')}>Home Address</option>
                <option value="Office Address" disabled={disabledAddressNames.includes('Office Address')}>Office Address</option>
                <option value="Other's Address" disabled={disabledAddressNames.includes("Other's Address")}>Other's Address</option>
              </select>
            </div>
            {newAddressType === "Other's Address" && (
              <div>
                <label>Enter Custom Address Name: </label>
                <input
                  type="text"
                  value={customAddressName}
                  onChange={(e) => setCustomAddressName(e.target.value)}
                />
              </div>
            )}
            {newAddressType && (
              <div>
                {Object.entries(newAddress).map(([key, value], index) => (
                  <div key={index}>
                    <label>{key}: </label>
                    <input
                      type="text"
                      name={key}
                      value={value}
                      onChange={handleNewAddressChange}
                    />
                  </div>
                ))}
              </div>
            )}
            <div className="address-actions">
              <button onClick={handleAddAddress} disabled={!newAddressType}>Save Address</button>
              <button onClick={() => setIsAddingAddress(false)}>Cancel</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Address;